/* tslint:disable */
/* eslint-disable */
/**
 * New Notifier Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * Contact: kohestanimahdi@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { CheckUnreadDtoApiResponse } from '../model';
// @ts-ignore
import { GetMessageListDtoApiResponse } from '../model';
// @ts-ignore
import { StringApiResponse } from '../model';
/**
 * UserMessagesApiApiCheckUnreadGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserMessagesApiApiCheckUnreadGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/CheckUnread`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserMessagesApiApiGetMessagesGet - axios parameter creator
 * 
 * @param {number} [page] 
 * @param {number} [pageSize] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserMessagesApiApiGetMessagesGetAxiosParamCreator (page?: number, pageSize?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetMessages`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (page !== undefined) {
        localVarQueryParameter['page'] = page;
    }

    if (pageSize !== undefined) {
        localVarQueryParameter['pageSize'] = pageSize;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * UserMessagesApiApiMessageChangeStatusGet - axios parameter creator
 * 
 * @param {number} [messageId] 
 * @param {string} [mac] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function UserMessagesApiApiMessageChangeStatusGetAxiosParamCreator (messageId?: number, mac?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Message/ChangeStatus`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (messageId !== undefined) {
        localVarQueryParameter['messageId'] = messageId;
    }

    if (mac !== undefined) {
        localVarQueryParameter['mac'] = mac;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiGetMessagesGet operation in UserMessagesApi.
 * @export
 * @interface UserMessagesApiApiGetMessagesGetRequest
 */
export interface UserMessagesApiApiGetMessagesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserMessagesApiApiGetMessagesGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof UserMessagesApiApiGetMessagesGet
     */
    readonly pageSize?: number
}

/**
 * Request parameters for apiMessageChangeStatusGet operation in UserMessagesApi.
 * @export
 * @interface UserMessagesApiApiMessageChangeStatusGetRequest
 */
export interface UserMessagesApiApiMessageChangeStatusGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UserMessagesApiApiMessageChangeStatusGet
     */
    readonly messageId?: number

    /**
     * 
     * @type {string}
     * @memberof UserMessagesApiApiMessageChangeStatusGet
     */
    readonly mac?: string
}

/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserMessagesApiApiCheckUnreadGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserMessagesApiApiCheckUnreadGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<CheckUnreadDtoApiResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserMessagesApiApiGetMessagesGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserMessagesApiApiGetMessagesGet(requestParameters: UserMessagesApiApiGetMessagesGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserMessagesApiApiGetMessagesGetAxiosParamCreator(requestParameters.page, requestParameters.pageSize, options, configuration);
    const request: () => AxiosPromise<GetMessageListDtoApiResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {UserMessagesApiApiMessageChangeStatusGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function UserMessagesApiApiMessageChangeStatusGet(requestParameters: UserMessagesApiApiMessageChangeStatusGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await UserMessagesApiApiMessageChangeStatusGetAxiosParamCreator(requestParameters.messageId, requestParameters.mac, options, configuration);
    const request: () => AxiosPromise<StringApiResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
